interface FilePreviewProps {
  files: File[];
  imageDataList: string[];
  onRemove: (index: number) => void;
}

const FilePreview = ({ files, imageDataList, onRemove }: FilePreviewProps) => {
  if (imageDataList.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 mb-2">
      {imageDataList.map((dataUrl, index) => (
        <div key={index} className="relative group">
          <img 
            src={dataUrl} 
            alt="Загруженное изображение" 
            className="h-20 w-20 object-cover rounded-lg border border-border"
          />
          <button
            onClick={() => onRemove(index)}
            className="absolute -top-2 -right-2 bg-destructive text-destructive-foreground rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>
      ))}
    </div>
  );
};

export default FilePreview;